import React from 'react';

import TripReviewContainer from './trip-review-container';
import { BackNavigationView } from '../../components/back-navigation';
import { getTripMatchReviewBackNavConfig } from '../../components/back-navigation/back-navigation-configs';
import { useBackNavigation } from '../../hooks/use-back-navigation';

const TripReview = () => {
  const { primaryText, handleBack } = useBackNavigation(getTripMatchReviewBackNavConfig);

  return (
    <>
      <BackNavigationView primaryText={primaryText} handleBack={handleBack} dataE2e="ztest-trip-review-back-match" />
      <TripReviewContainer />
    </>
  );
};

export default TripReview;
